import React from "react";
import Carousel from "react-bootstrap/Carousel";
// import img2 from "./images/highway.png";
// import img3 from "./images/software-developer.png";
import img1 from "./images/themePage.png";
import "../styles/CarouselPage.css";

function CarouselPage() {
  return (
    <div>
      <Carousel>
        <Carousel.Item interval={1000}>
          <img
            style={{ height: "92vh" }}
            className="d-block w-100"
            src={img1}
            alt="First slide"
          />
          {/* <Carousel.Caption>
            <h3>First slide label</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </Carousel.Caption> */}
        </Carousel.Item>
        <Carousel.Item interval={1000}>
          <img
            style={{ height: "92vh" }}
            className="d-block w-100"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/2017_four_lane_state_highway_SH_49_Tamil_Nadu_India.jpg/1200px-2017_four_lane_state_highway_SH_49_Tamil_Nadu_India.jpg?20171104000726"
            alt="Second slide"
          />

          <Carousel.Caption interval={1000}>
            <h3>Construction Service</h3>
            <p>We provide all types of construction services.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            style={{ height: "92vh" }}
            className="d-block w-100"
            src="https://cdn.pixabay.com/photo/2021/08/04/13/06/software-developer-6521720_1280.jpg"
            alt="Third slide"
          />

          <Carousel.Caption>
            <h3>IT Solutions</h3>
            <p>We are offering edge-cutting IT solutions.</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default CarouselPage;
